import { createContext } from 'react';

const ReporteComisionesContext = createContext();

export default ReporteComisionesContext;
